import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';

function BeforeAndAfter() {
  return (
    <Wrapper>
      <BoxWrapper>
        <Annotation>Typical Shadow</Annotation>
        <BoringShadow></BoringShadow>
      </BoxWrapper>
      <BoxWrapper>
        <Annotation>Optimized Shadow</Annotation>
        <NiceShadow></NiceShadow>
      </BoxWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  padding: 96px 48px;
  margin-bottom: 32px;
  gap: 48px;
  background: hsl(285deg 90% 90%);
  border-radius: 16px;

  @media ${BREAKPOINTS.smAndSmaller} {
    flex-direction: column;
    justify-content: unset;
    align-items: center;
    gap: 96px;
  }
`;

const Box = styled.div`
  position: relative;
  width: 150px;
  height: 150px;
  background: white;
  border-radius: 8px;
`;

const BoxWrapper = styled.div`
  position: relative;
`;

const BoringShadow = styled(Box)`
  box-shadow: 3px 6px 6px hsl(0deg 0% 0% / 0.35);
`;
const NiceShadow = styled(Box)`
  /* prettier-ignore */
  filter:
    drop-shadow(0.5px 1px 1px hsl(285deg 40% 40% / 0.15))
    drop-shadow(1px 2px 2px hsl(285deg 40% 40% / 0.15))
    drop-shadow(2px 4px 4px hsl(285deg 40% 40% / 0.15))
    drop-shadow(4px 8px 8px hsl(285deg 40% 40% / 0.15))
    drop-shadow(8px 16px 16px hsl(285deg 40% 40% / 0.15));
`;

const Annotation = styled.p`
  position: absolute;
  top: -24px;
  left: 0;
  width: 100%;
  font-size: 1rem;
  font-weight: var(--font-weight-medium);
  text-align: center;
  color: hsl(285deg 25% 25%);
  transform: translateY(-100%);

  @media ${BREAKPOINTS.smAndSmaller} {
    top: -8px;
  }
`;

export default BeforeAndAfter;
